import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { emptyArray } from 'ui-components/default-props/empty';
import { locationNameFromParts } from '../../products/product-details/display-helpers';
import Global from '../../store/global-selectors';

type WarehouseLocation = {
  inventoryLocationId: string;
  inventoryWarehouseId: string;
  area: string;
  bin: string;
  shelf: string;
  unit: string;
};

type LocationOption = {
  key: string;
  name: string;
};

/**
 * Returns sorted warehouse location options for a given warehouse
 */
export const useSortedWarehouseLocations = (warehouseId: string): LocationOption[] => {
  const locations: WarehouseLocation[] =
    useSelector((state) =>
      Global.selectSellerInventoryWarehouseLocationsByWarehouseId(state, {
        inventoryWarehouseId: warehouseId,
      }),
    ) || emptyArray;

  return useMemo(() => {
    return locations
      .map((loc: WarehouseLocation) => ({
        key: loc.inventoryLocationId,
        name: locationNameFromParts(loc),
      }))
      .sort((a: LocationOption, b: LocationOption) => a.name.localeCompare(b.name));
  }, [locations]);
};
